module.exports = __webpack_public_path__ + "static/media/timeline-bg.25fb9ac8.png";